import { useMemo } from 'react';
import { useSiteContext } from '../../SiteContext';
export function useSiteDialogComponents() {
    const { plugins, siteComponents, setSiteComponents, subscribe, unsubscribe } = useSiteContext();
    // Subscribe to any component changes coming from the component editor
    // useEffect(() => {
    //   const handleSubscribe = () => {
    //     setSiteComponents(components => [...components]);
    //   };
    //   subscribe('dialog', handleSubscribe);
    //   return () => unsubscribe('dialog', handleSubscribe);
    // }, [setSiteComponents, subscribe, unsubscribe]);
    return useMemo(() => {
        const dialogTypes = plugins
            .filter(p => { var _a; return (_a = p.categories) === null || _a === void 0 ? void 0 : _a.includes('dialog'); })
            .map(p => p.type);
        return siteComponents
            .filter(c => dialogTypes.includes(c.type))
            .sort((a, b) => {
            var _a, _b, _c, _d;
            const titleA = ((_b = (_a = a.props) === null || _a === void 0 ? void 0 : _a.title) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || '';
            const titleB = ((_d = (_c = b.props) === null || _c === void 0 ? void 0 : _c.title) === null || _d === void 0 ? void 0 : _d.toLowerCase()) || '';
            return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
        });
    }, [plugins, siteComponents]);
}
//# sourceMappingURL=useSiteDialogComponents.js.map